import { NavigationLink, NavigationSection } from './types'

const matchesExactOrPrefix = (
    item: NavigationLink,
    currentPath: string,
): boolean =>
    item.activePathPrefix
        ? currentPath.startsWith(item.activePathPrefix)
        : currentPath === item.href

const matchesChildRoute = (
    item: NavigationLink,
    currentPath: string,
): boolean =>
    !item.activePathPrefix &&
    item.href !== '/' &&
    currentPath.startsWith(`${item.href}/`)

export const isNavigationRouteInSection = (
    item: NavigationLink,
    currentPath: string,
): boolean =>
    matchesExactOrPrefix(item, currentPath) ||
    matchesChildRoute(item, currentPath)

export const isNavigationSectionActive = (
    section: NavigationSection,
    currentPath: string,
): boolean =>
    section.items
        .filter((item) => item.enabled)
        .some((item) => isNavigationRouteInSection(item, currentPath))

export const isNavigationLinkActive = (
    item: NavigationLink,
    currentPath: string,
    sectionItems: NavigationLink[] = [],
): boolean => {
    if (matchesExactOrPrefix(item, currentPath)) {
        return true
    }

    const enabledItems = sectionItems.filter(
        (sectionItem) => sectionItem.enabled,
    )
    const hasExactMatch = enabledItems.some((sectionItem) =>
        matchesExactOrPrefix(sectionItem, currentPath),
    )
    if (hasExactMatch || !matchesChildRoute(item, currentPath)) {
        return false
    }

    const childMatches = enabledItems.filter((sectionItem) =>
        matchesChildRoute(sectionItem, currentPath),
    )
    const bestMatch = childMatches.reduce((longest, candidate) =>
        candidate.href.length >= longest.href.length ? candidate : longest,
    )

    return item.value === bestMatch.value
}
